
'use client';

import * as React from 'react';
import { Compass } from 'lucide-react';
import { cn } from '@/lib/utils';

const loadingTexts = [
  "Booting up Noor Navigator...",
  "Finding halal restaurants near you...",
  "Catching all mosques in your vicinity...",
  "Compiling local Muslim businesses...",
  "Finalizing the map...",
];

export default function LoadingAnimation() {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [fade, setFade] = React.useState(true);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
        setFade(true); // Start fade in
      }, 500); // Time for fade out animation
    }, 2500); // Time each message is displayed + fade time

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col h-full items-center justify-center bg-background p-8 text-center">
      <Compass className="w-16 h-16 text-primary animate-pulse mb-8" />
      <div className="h-6">
         <h2 
            className={cn(
                "text-xl font-semibold text-foreground transition-opacity duration-500",
                fade ? "opacity-100" : "opacity-0"
            )}
        >
            {loadingTexts[currentIndex]}
        </h2>
      </div>
    </div>
  );
}
